/**
 * 友盟统计工具函数
 */

// 声明全局 aplus_queue 类型
declare global {
    interface Window {
        aplus_queue?: Array<{
            action: string;
            arguments: any[];
        }>;
    }
}

/**
 * 发送 PV 统计
 */
export const sendPV = () => {
    if (typeof window !== 'undefined' && window.aplus_queue) {
        window.aplus_queue.push({
            action: 'aplus.sendPV',
            arguments: [
                {
                    is_auto: false
                }, {}
            ],
        });
    }
};

